import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useSaleProductNames } from "./SalePrice";

export const AnnouncementBar = () => {
  const { activeSeasonal } = useCart();
  const saleNames = useSaleProductNames();
  return (
    <div
      data-testid="announcement-bar"
      className="bg-charcoal-600 text-cream-100 text-[11px] sm:text-xs tracking-[0.18em] uppercase py-2.5 text-center font-medium"
    >
      <div className="container-x flex items-center justify-center gap-2 sm:gap-4 flex-wrap">
        {activeSeasonal && (
          <>
            <Link
              to={`/product/${activeSeasonal.product_ids[0]}`}
              data-testid="announcement-seasonal-promo"
              className="basis-full sm:basis-auto text-[#F2C9B8] hover:text-white transition-colors"
            >
              {activeSeasonal.name}: {activeSeasonal.percent}% off {saleNames}
            </Link>
            <span className="hidden sm:inline opacity-40">•</span>
          </>
        )}
        <span>For Research Use Only</span>
        <span className="opacity-40">•</span>
        <span>21+ Only</span>
      </div>
    </div>
  );
};

export default AnnouncementBar;
